import Symbol from './Symbol';
import SymbolMap from './SymbolMap';
import NumberPad from './NumberPad';
import { PRACTICE_COUNT, type Feedback } from '@/pages/dsst/dsstConfig';

interface PracticeScreenProps {
  symbolMap: number[];
  currentSymbol: number;
  selectedNumber: number | null;
  feedback: Feedback;
  practiceIndex: number;
  setIndex: number;
  onSelect: (n: number) => void;
  onClose: () => void;
}

export default function PracticeScreen({
  symbolMap,
  currentSymbol,
  selectedNumber,
  feedback,
  practiceIndex,
  setIndex,
  onSelect,
  onClose,
}: PracticeScreenProps) {
  const feedbackText =
    feedback === 'correct'
      ? '정답이에요!'
      : feedback === 'wrong'
        ? '이런! 다시 생각해보세요'
        : '';

  return (
    <div className="flex flex-col h-full px-4 pt-[var(--dsst-pt)] pb-[var(--dsst-pb)] bg-white animate-fade-in-up">
      {/* 게임명 + 연습 진행 + 닫기 (본게임과 동일한 헤더 구조) */}
      <div className="shrink-0 flex items-center justify-between mb-3">
        <span className="text-base font-bold text-foreground-900 whitespace-nowrap">
          기호 맞추기
        </span>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground-500 whitespace-nowrap">
            연습 {practiceIndex + 1} / {PRACTICE_COUNT}
          </span>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full active:bg-secondary-100 transition-colors duration-150"
            aria-label="닫기"
          >
            <i className="ri-close-line text-xl text-foreground-700" />
          </button>
        </div>
      </div>

      {/* 기호-숫자 대응표 */}
      <div className="shrink-0 bg-primary-50 rounded-xl px-3 py-2.5 mb-2">
        <SymbolMap
          symbolMap={symbolMap}
          setIndex={setIndex}
          symbolSizeClass="w-[var(--dsst-map-symbol)] h-[var(--dsst-map-symbol)]"
        />
      </div>

      {/* 문제 영역 */}
      <div className="flex-1 min-h-0 flex flex-col items-center justify-center">
        <p className="text-base font-semibold text-foreground-700 text-center leading-snug">
          이 기호와 짝이 되는 숫자는?
        </p>
        <div className="mt-2.5 flex items-center justify-center text-primary-600">
          <Symbol
            symbolId={currentSymbol}
            setIndex={setIndex}
            className="w-[var(--dsst-symbol-size)] h-[var(--dsst-symbol-size)]"
          />
        </div>
        {/* 피드백 라벨 — 기호 하단에 배치 */}
        {feedbackText && (
          <div className="mt-3 flex items-center justify-center">
            <span
              className={`inline-flex items-center px-3.5 py-1.5 rounded-full text-sm font-bold whitespace-nowrap ${
                feedback === 'correct'
                  ? 'bg-green-100 text-green-700'
                  : 'bg-red-100 text-red-500'
              }`}
            >
              {feedbackText}
            </span>
          </div>
        )}
      </div>

      {/* 숫자 선택 */}
      <div className="shrink-0 mt-2">
        <NumberPad
          onSelect={onSelect}
          selectedNumber={selectedNumber}
          feedback={feedback}
          disabled={feedback !== null}
        />
      </div>
    </div>
  );
}